/**
 * Tiny pill that surfaces the upstream data source and a `stale` flag.
 *
 * source: "yfinance" | "coingecko" | "twelvedata"
 * stale:  optional — true when the response was served from an extended/stale cache
 */
import React from "react";
import { Database, AlertTriangle } from "lucide-react";

const SOURCE_LABEL = {
  yfinance: "Yahoo",
  coingecko: "CoinGecko",
  twelvedata: "TwelveData",
};

export default function DataSourceBadge({ source, stale, className = "" }) {
  if (!source && !stale) return null;
  const label = SOURCE_LABEL[source] || source;

  return (
    <div
      className={`inline-flex items-center gap-1.5 ${className}`}
      data-testid="data-source-badge"
    >
      {label && (
        <span
          className="inline-flex items-center gap-1 text-[10px] uppercase tracking-[0.18em] font-semibold text-[#6B7068] bg-[#F9F8F6] border border-[#EAE6E1] rounded-full px-2 py-1"
          data-testid={`source-${source}`}
          title={`Data provider: ${label}`}
        >
          <Database className="w-3 h-3" strokeWidth={1.75} />
          {label}
        </span>
      )}
      {stale && (
        <span
          className="inline-flex items-center gap-1 text-[10px] uppercase tracking-[0.18em] font-semibold text-[#E8A25D] bg-[#E8A25D]/10 border border-[#E8A25D]/30 rounded-full px-2 py-1"
          data-testid="source-stale"
          title="Data is from cache. Live feed is currently rate-limited."
        >
          <AlertTriangle className="w-3 h-3" strokeWidth={1.75} />
          Cached
        </span>
      )}
    </div>
  );
}
